// eslint-disable-next-line import/no-cycle
import {
  stringLogicalOperators,
} from '@/composables/segmentations/logicalOperators';

/**
 * Get the current page properties segments for navigation context
 * These segments are evaluated against the current page's URL context
 */
export const getCurrentPagePropertiesSegments = (includeContext = false) => [
  {
    id: 'url',
    label: 'segmentations.navigation.currentPage.url',
    logical_operators: stringLogicalOperators('url'),
    ...(includeContext && { context: 'navigation.currentPage.url' }),
  },
];

export default getCurrentPagePropertiesSegments;
